import {AppState} from '../../../../store/states/app.state';
import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';


export class AppNavigationSelectors {

  private static select = {
    buttonStates: (state: AppState) => state.appNavigation.buttonStates,
  };

  public static allButtonStates = createSelector(
    this.select.buttonStates,
    identity,
  );

  public static buttonEnabled = (buttonId: string) => createSelector(
    this.select.buttonStates,
    (buttonStates) => buttonStates[buttonId] ?? true,
  );

}
